// constants/map.js
// Created: 2026-03-11 15:30:00 EST
// Updated: 2026-03-11 16:30:00 EST
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.0
//
// Map/geography constants: place type labels, colours, and Lucide icon
// associations for the Leaflet journey map.
//
// NOTE: PLACE_TYPE_ICONS references Lucide icon components directly.
// Import whichever icons are needed alongside this file, or import them
// here if this module is the single source of truth for map rendering.

import { Home, Lock, Hammer, Skull, Train, Bird } from 'lucide-react';

export const PLACE_TYPE_LABELS = {
  birthplace:          'Birthplace',
  ghetto:              'Ghetto',
  labour_camp:         'Labour Camp',
  extermination_camp:  'Extermination Camp',
  transit:             'Transit',
  liberation:          'Liberation',
  postwar:             'Post-war',
};

export const PLACE_TYPE_COLOURS = {
  birthplace:         '#3b82f6',
  ghetto:             '#f59e0b',
  labour_camp:        '#ef4444',
  extermination_camp: '#7c3aed',
  transit:            '#6b7280',
  liberation:         '#34c759',
  postwar:            '#06b6d4',
};

export const PLACE_TYPE_ICONS = {
  birthplace:         Home,
  ghetto:             Lock,
  labour_camp:        Hammer,
  extermination_camp: Skull,
  transit:            Train,
  liberation:         Bird,
  postwar:            Home,
};
